import { useSession } from 'src/sdk/session'
// import { getCookie } from 'src/utils/cookie'

export const useErrorComponentEvent = (componentName: string) => {
  const { person } = useSession()
  // const uuidToUse = getCookie('uuid')

  const sendErrorComponentEvent = (data: unknown) => {
    window?.postMessage({
      name: 'AnalyticsEvent',
      params: {
        name: 'store:erro_componente',
        params: {
          location: window?.location?.href,
          page: window?.location?.pathname,
          visitorId: person?.id ?? null,
          email: person?.email ?? null,
          component: componentName,
          data,
          user_logged: !!person?.id,
          user_id: person?.id ?? null,
          // uuid: uuidToUse
        },
      },
    })
  }

  return { sendErrorComponentEvent }
}
